import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	value: 0,
};

const qCardSlice = createSlice({
	name: "qCardTrainingHours",
	initialState: initialState,
	reducers: {
		updateQCard(state, action) {
			// console.log("update qCardTrainingHours");
			// console.log(action);

			state.value = action.payload.value;
		},
	},
});

export const qCardTrainingHoursActions = qCardSlice.actions;

export default qCardSlice;
